module.exports = __webpack_public_path__ + "static/img/IMG_20151222_183754.c5fa11f2.jpg";